import { render, staticRenderFns } from "./IndexAuth.vue?vue&type=template&id=4f11a662&"
import script from "./IndexAuth.vue?vue&type=script&lang=js&"
export * from "./IndexAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports